import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/_alert';
import { LoginService } from 'src/app/_services/login.service';

@Component({
  selector: 'app-forgot-pass',
  templateUrl: './forgot-pass.component.html',
  styleUrls: ['./forgot-pass.component.css']
})
export class ForgotPassComponent implements OnInit {

  submitted: boolean = true;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  constructor(
    public loginService: LoginService,
    public alertService: AlertService
  ) { }

  ngOnInit(): void {
  }

  forgotForm: FormGroup = new FormGroup(
    {
      UserName: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")])
    })

  get forms() {
    return this.forgotForm.controls;
  }

  forgetPassword() {
    this.submitted = true;
    if (this.forgotForm.valid) {
      this.loginService.forgotPassword(this.forgotForm.value.UserName).subscribe((response) => {
        console.log(response);
        this.alertService.success('Password reset link has been sent to your mail.Please check your mail', this.options);
      }, (error) => {
        console.log(error);
      })
    }
    else {
      this.alertService.error('Error!! Please Enter valid data.', this.options);
    }
  }
}
